import {
  CONTACT_PAYWALL_EXPERIMENT_ID,
  FIRST_ECHO_PAYGATE_EXPERIMENT_ID,
} from "../experiments/experimentClient";

/**
 * A monetization read model the Monetization tab can point at. Each one is a
 * DynamoDB partition (`EXPERIMENT#<id>`) fed by the bot's commerce outbox, so
 * the tab must ask for the id the bot is writing to today.
 */
export type MonetizationExperiment = {
  id: string;
  label: string;
  description: string;
  /** Currently receiving assignments and Stripe facts. */
  live: boolean;
  /**
   * Which metrics block the headline uses. The contact paywall assigns every
   * B2C contact to a paid variant, so its totals are the treatment; the
   * Meta-ads A/B kept a free control and is read per variant.
   */
  headline: "totals" | "pay_after_first_echo";
  /** Variant filter for the journey board; null shows every assignment. */
  boardVariant: string | null;
  /** The rollout was gated on verified paid Meta acquisition evidence. */
  requiresMetaAdEvidence: boolean;
};

export const MONETIZATION_EXPERIMENTS: readonly MonetizationExperiment[] = [
  {
    id: CONTACT_PAYWALL_EXPERIMENT_ID,
    label: "Contact paywall (live)",
    description:
      "Every B2C contact gets the free allowance, then must buy (1 Echo · €1.99 for contacts created since 29 Sep 2026, €0.99 for earlier contacts; 5 Echoes · €7.50) or refer a friend. Both the hard block on Create and the soft post-rating offer land here.",
    live: true,
    headline: "totals",
    boardVariant: null,
    requiresMetaAdEvidence: false,
  },
  {
    id: FIRST_ECHO_PAYGATE_EXPERIMENT_ID,
    label: "Meta-ads paygate A/B (Jul–Aug 2026)",
    description:
      "First-Echo paygate for new contacts attributed to Meta ads on WhatsApp, the website or Launchpad. Frozen; kept for the historical comparison.",
    live: false,
    headline: "pay_after_first_echo",
    boardVariant: "pay_after_first_echo",
    requiresMetaAdEvidence: true,
  },
  {
    id: "first-echo-paygate-v1",
    label: "Paygate pilot (Jul 2026)",
    description:
      "The first signed paygate experiment, exercised by team numbers on the €1.85 single. Frozen.",
    live: false,
    headline: "pay_after_first_echo",
    boardVariant: null,
    requiresMetaAdEvidence: false,
  },
];

export const DEFAULT_MONETIZATION_EXPERIMENT = MONETIZATION_EXPERIMENTS[0];

export function resolveMonetizationExperiment(
  id: string | null | undefined,
): MonetizationExperiment {
  return (
    MONETIZATION_EXPERIMENTS.find((experiment) => experiment.id === id) ??
    DEFAULT_MONETIZATION_EXPERIMENT
  );
}
